/**
 * Runtime configuration — single source of truth for environment values.
 * Never read `import.meta.env` directly anywhere else in the app.
 */

const BACKEND_BASE = (import.meta.env.VITE_BACKEND_URL ?? "/api").replace(/\/+$/, "");

export const env = {
  backendBase: BACKEND_BASE,
  apiV1: `${BACKEND_BASE}/api/v1`,

  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? "",
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? "",

  isDev: import.meta.env.DEV,

  /**
   * When true, the app should allow unauthenticated dev access via the
   * `x-dev-user` header. Toggle via `?dev=<email>` query param or the
   * `rentier.devUser` localStorage key.
   */
  devAuthEnabled:
    import.meta.env.DEV &&
    (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? "") === "",
} as const;
